/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import NotableInfo from "reusables/TextFormats/NotableInfo";

function Extra_Services({ description, services }) {
  const calculateNumRows = () => {
    if (services.length === 0) {
      return 0;
    }
    return Math.ceil(services.length / 3);
  };

  const numRows = calculateNumRows(services);
  const totalItems = numRows * 3;

  //   console.log("services.length", services.length);
  //   console.log("numRows", numRows);
  //   console.log("totalItems", totalItems);

  return (
    <Grid
      container
      item
      display={"flex"}
      flexDirection={"column"}
      // alignItems="center"
      // bgcolor={"pink"}
      width={"100%"}
    >
      <Grid item>
        <SubTitleContents title="Extra Optional Services" contents={description} />
      </Grid>
      <Divider width="100%" sx={{ width: "100%", my: 2, borderWidth: 2 }} />
      <Grid
        container
        display={"flex"}
        flexDirection={"row"}
        justifyContent="space-between"
        width={"100%"}
        mb={2}
      >
        {Array.from({ length: totalItems }).map((_, index) => {
          if (services[index] === undefined) {
            return (
              <Grid
                item
                xs={12}
                lg={4}
                // display={"flex"}
                // flexDirection={"row"}
                pr={3}
                key={index}
                // bgcolor={"yellow"}
              >
                <MKBox />
              </Grid>
            );
          } else {
            return (
              <Grid
                item
                xs={12}
                lg={4}
                display={"flex"}
                flexDirection={"row"}
                pr={3}
                key={index}
                // bgcolor={"pink"}
              >
                <MKBox display="flex" mr={1}>
                  <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
                    add
                  </Icon>
                </MKBox>
                <MKBox display="flex">
                  <MKTypography
                    variant="body2"
                    color="text"
                    sx={{ textAlign: "justify", wordbreak: "break-all" }}
                  >
                    {services[index]}
                  </MKTypography>
                </MKBox>
              </Grid>
            );
          }
        })}
      </Grid>
      <Divider width="100%" sx={{ width: "100%", my: 2, borderWidth: 2 }} />
      <NotableInfo
        text={
          "Let us know your specific needs, and we’ll tailor our services to ensure every corner of your space meets your expectations. Contact us to request additional services!"
        }
      />
      {/* <MKBox
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        // sx={{ bgcolor: "lightblue" }}
        width={"100%"}
      >
        <MKBox display="flex" pr={1}>
          <Icon fontSize="medium" color="info">
            info
          </Icon>
        </MKBox>
        <MKBox display="flex">
          <MKTypography variant="body2" color="info" fontWeight="bold">
            Let us know your specific needs, and we’ll tailor our services to ensure every corner of
            your space meets your expectations. Contact us to request additional services!
          </MKTypography>
        </MKBox>
      </MKBox> */}
    </Grid>
  );
}
Extra_Services.propTypes = {
  description: PropTypes.string,
  services: PropTypes.array,
};

export default Extra_Services;

// /* eslint-disable no-unused-vars */
// import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
// import Icon from "@mui/material/Icon";
// import PropTypes from "prop-types";
// import Divider from "@mui/material/Divider";

// // Material Kit 2 React components
// import MKBox from "components/MKBox";
// import MKTypography from "components/MKTypography";
// import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// function Additional_Services({ services }) {
//   const calculateNumRows = () => {
//     if (services.length === 0) {
//       return 0;
//     }
//     return Math.ceil(services.length / 3);
//   };

//   const numRows = calculateNumRows(services);
//   const totalItems = numRows * 3;

//   //   console.log("services.length", services.length);
//   //   console.log("numRows", numRows);
//   //   console.log("totalItems", totalItems);

//   return (
//     <MKBox width="100%">
//       <Divider width="100%" sx={{ width: "100%", my: 2, borderWidth: 2 }} />
//       <Grid
//         container
//         display={"flex"}
//         flexDirection={"row"}
//         justifyContent="space-between"
//         width={"100%"}
//         mb={2}
//       >
//         {Array.from({ length: totalItems }).map((_, index) => {
//           if (services[index] === undefined) {
//             return (
//               <Grid
//                 item
//                 xs={12}
//                 md={4}
//                 // display={"flex"}
//                 // flexDirection={"row"}
//                 pr={3}
//                 key={index}
//                 // bgcolor={"yellow"}
//               >
//                 <MKBox />
//               </Grid>
//             );
//           } else {
//             return (
//               <Grid
//                 item
//                 xs={12}
//                 md={4}
//                 display={"flex"}
//                 flexDirection={"row"}
//                 pr={3}
//                 key={index}
//                 // bgcolor={"pink"}
//               >
//                 <MKBox display="flex" mr={1}>
//                   <Icon fontSize="small" sx={{ fontWeight: "bold" }}>
//                     add
//                   </Icon>
//                 </MKBox>
//                 <MKBox display="flex">
//                   <MKTypography
//                     variant="body2"
//                     color="text"
//                     sx={{ textAlign: "justify", wordbreak: "break-all" }}
//                   >
//                     {services[index]}
//                   </MKTypography>
//                 </MKBox>
//               </Grid>
//             );
//           }
//         })}
//       </Grid>
//       <Divider width="100%" sx={{ width: "100%", my: 2, borderWidth: 2 }} />
//       <MKBox
//         display={"flex"}
//         flexDirection={"row"}
//         alignItems={"center"}
//         // sx={{ bgcolor: "lightblue" }}
//         width={"100%"}
//       >
//         <MKBox display="flex" pr={1}>
//           <Icon fontSize="medium" color="info">
//             info
//           </Icon>
//         </MKBox>
//         <MKBox display="flex">
//           <MKTypography variant="body2" color="info" fontWeight="bold">
//             If your office requires additional services, we’re happy to provide them! These add-ons
//             can be arranged at your request based on your specific needs.
//           </MKTypography>
//         </MKBox>
//       </MKBox>
//     </MKBox>
//   );
// }
// Additional_Services.propTypes = {
//   services: PropTypes.array.isRequired,
// };

// export default Additional_Services;
